module.exports = __webpack_public_path__ + "static/media/utensils-alt.c4f89fb9.svg";